import { useState } from "preact/hooks";
import type { LeadPayload } from "../lib/types";

type LeadCaptureFormProps = {
  disabled: boolean;
  onSubmit: (lead: LeadPayload) => void;
  onDismiss: () => void;
};

export default function LeadCaptureForm({ disabled, onSubmit, onDismiss }: LeadCaptureFormProps) {
  const [lead, setLead] = useState<LeadPayload>({
    name: "",
    email: "",
    phone: "",
    need: ""
  });

  function updateField(field: keyof LeadPayload, value: string) {
    setLead((current) => ({ ...current, [field]: value }));
  }

  function handleSubmit(event: Event) {
    event.preventDefault();

    if (disabled || !lead.name.trim() || !lead.email.trim() || !lead.need.trim()) {
      return;
    }

    onSubmit({
      name: lead.name.trim(),
      email: lead.email.trim(),
      phone: lead.phone.trim(),
      need: lead.need.trim()
    });
  }

  return (
    <form className="qk-chatbot-lead" onSubmit={handleSubmit}>
      <div className="qk-chatbot-lead-header">
        <p>Vos coordonnees</p>
        <button type="button" aria-label="Masquer le formulaire" onClick={onDismiss}>
          &times;
        </button>
      </div>
      <input
        type="text"
        value={lead.name}
        maxLength={160}
        placeholder="Nom"
        disabled={disabled}
        required
        onInput={(event) => updateField("name", (event.currentTarget as HTMLInputElement).value)}
      />
      <input
        type="email"
        value={lead.email}
        maxLength={320}
        placeholder="Email"
        disabled={disabled}
        required
        onInput={(event) => updateField("email", (event.currentTarget as HTMLInputElement).value)}
      />
      <input
        type="tel"
        value={lead.phone}
        maxLength={80}
        placeholder="Telephone"
        disabled={disabled}
        onInput={(event) => updateField("phone", (event.currentTarget as HTMLInputElement).value)}
      />
      <textarea
        value={lead.need}
        maxLength={1000}
        placeholder="Votre besoin"
        disabled={disabled}
        required
        onInput={(event) => updateField("need", (event.currentTarget as HTMLTextAreaElement).value)}
      />
      <button type="submit" disabled={disabled || !lead.name.trim() || !lead.email.trim() || !lead.need.trim()}>
        Transmettre
      </button>
    </form>
  );
}
